var map = {
	"./adventure-of-link.jpg": "56af",
	"./battlescapes.jpg": "d2fc",
	"./four-swords-adventure.jpg": "b5f9",
	"./home.jpg": "6da8",
	"./legend-of-zelda.jpg": "b980",
	"./link-to-the-past.jpg": "ed94",
	"./links-awakening.jpg": "f5ae",
	"./majoras-mask.jpg": "04ed",
	"./minish-cap.jpg": "ef51",
	"./ocarina-of-time.jpg": "0f8a",
	"./open-symphony.jpg": "95da",
	"./oracle-of-ages.jpg": "2a0f",
	"./oracle-of-seasons.jpg": "9ead",
	"./phantom-hourglass.jpg": "6e13",
	"./skyward-sword.jpg": "4667",
	"./soundscape-vol-1.jpg": "4e96",
	"./soundscape-vol-2.jpg": "79ed",
	"./soundscape-vol-3.jpg": "9b03",
	"./spirit-tracks.jpg": "7731",
	"./twilight-princess.jpg": "18b5",
	"./twilight-symphony.jpg": "3568",
	"./wind-waker.jpg": "150b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cd52";